import Button from "@/components/Common/Buttons/Button/Button.vue";
import ModalCloseBtn from "@/components/Modal/ModalCloseBtn.vue";
import Modal from "@/components/Modal/Modal.vue";
import LoadingCircle from "@/components/Common/Icons/LoadingCircle.vue";
import ErrorIcon from "@/components/Common/Icons/ErrorIcon.vue";


export default {
    name: 'NotificationModal',
    components: {
        ErrorIcon,
        LoadingCircle,
        ModalCloseBtn,
        Modal
    },
    props: {
        theme: {
            type: String,
            default: 'regular'
        },
    },
    data() {
        return {
            isMobileMenuOpen: false
        }
    },
    mounted() {
        let vm = this;
    },
    methods: {
        closeModal() {
            this.$store.dispatch("utils/closeNotificationModal");
        },
    }
}